import { VIDEOS } from './actionTypes';
import { VideoMapper } from 'mappers/videos';
import { CommonMapper } from 'mappers/common';

const getVideosData = (vertical_id, url_slug, type, vertical_name) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: VIDEOS.VIDEOS_REQUEST,
    payload: {},
    test: api
      .post(`getVideoSections.json`, { vertical_id, url_slug, type })
      .then(res => {
        const response = res.data.data || {};
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: VIDEOS.VIDEOS_SUCCESS,
          payload: VideoMapper.mapVideosSection(
            response,
            mediaPath,
            vertical_name
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: VIDEOS.VIDEOS_FAILURE,
          error,
        });
      }),
  });
};

export const VideoActions = {
  getVideosData,
};
